import type { ChannelShareData } from "@/call-details/api/types";
import type { Partner } from "@/shared-types";

export function shouldShowCallIntroFlowQuestions(partner: Partner, callDetails: ChannelShareData): boolean {
    return partner !== "youtubetv" || (partner === "youtubetv" && callDetails?.CLIENT !== "ASURION_CARE_STREAMING");
}
